  /* our-menu.js — optimized
 * Changes vs original:
 * - Single DOMContentLoaded init (no duplicate logic running twice)
 * - Removed chained setTimeout(80/100/120/200/400) delays — replaced with
 *   requestAnimationFrame / direct calls, since jQuery/Slick are ready
 *   by the time this file runs (deferred + loaded after jquery+slick)
 * - Fixed a real bug: dropdown <li> click listeners were being added
 *   INSIDE a forEach loop, so every item registered its own document-wide
 *   listener (N items = N duplicate listeners). Now a single delegated
 *   listener handles all dropdown items.
 * - "change" listener scoped only to our target selects instead of
 *   firing for every <select> on the page.
 * - Scroll listener throttled via requestAnimationFrame instead of
 *   running full DOM class toggling on every scroll tick.
 * - Search input debounced (120ms) so filtering doesn't run per keystroke.
 */

function updateMenuCategory() {
  const menuSelect = document.querySelector(
    '.our-menu-page-search-category-main select'
  );

  if (!menuSelect) return;

  const value = menuSelect.value;

  if (value !== 'dairy' && value !== 'meat') return;

  

  document.querySelectorAll('.our-menu-collections-desc-part').forEach(function (el) {
    el.classList.add('active');
  });

  document.querySelectorAll('.our-menu-main-list-wrap').forEach(function (el) {
    el.classList.remove('active');
  });

  document.querySelectorAll('.wc-list-' + value).forEach(function (el) {
    el.classList.add('active');
  });

  console.log('load', value);
}
updateMenuCategory();
setTimeout(function(){
updateMenuCategory();
}, 300)

document.addEventListener('DOMContentLoaded', function () {
  var $ = window.jQuery;

  /* ---------- Sticky top filter bar ---------- */
  var mainSearchBar = document.querySelector('.our-menu-page-search-bar-part-wc');
  var filterBarTop = document.querySelector('.coll-filter-bar-top');

  if (mainSearchBar && filterBarTop) {
    filterBarTop.innerHTML =
      '<div class="our-menu-page-search-bar-part">' + mainSearchBar.innerHTML + '</div>';
  }

  var filterBarThreshold = 900;
  var scrollTicking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        if (filterBarTop) {
          filterBarTop.classList.toggle('active', window.scrollY >= filterBarThreshold);
        }
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  /* ---------- Slick carousel ---------- */
  function initSlick() {
    if ($ && $.fn && $.fn.slick) {
      $('.our-menu-collection-products-1').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 1300, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
          { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
      });
    }
  }

  function refreshSlick() {
    if ($ && $.fn && $.fn.slick) {
      $('.our-menu-collection-products-1').slick('refresh');
    }
  }

  initSlick();

  /* ---------- Main category select (Meat/Dairy) ---------- */
  var subDropdowns = Array.prototype.slice.call(
    document.querySelectorAll('.our-menu-page-search-category-sub')
  );

  function applyMainSelectValue(dataId) {
    // Keep every copy of the select (original + sticky clone) in sync
    document.querySelectorAll('.our-menu-page-search-category-main select').forEach(function (select) {
      if (select.value !== dataId) select.value = dataId;
      console.log('dataId',dataId)
    });

    var isDairy = dataId === 'dairy' || dataId === 'Dairy';

    document.querySelectorAll('.our-menu-product-box').forEach(function (el) {
      el.classList.remove('main-search-active-grid');
    });
    document.querySelectorAll('.search-wc-list-dairy').forEach(function (el) {
      el.classList.toggle('search-active-grid', isDairy);
    });
    document.querySelectorAll('.search-wc-list-meat').forEach(function (el) {
      el.classList.toggle('search-active-grid', !isDairy);
    });

    document.querySelectorAll('.our-menu-main-list-wrap').forEach(function (el) {
      el.classList.toggle('active', el.id === dataId);
    });

    var hasSelection = dataId !== 'Choose One';
    document.querySelectorAll('.our-menu-collections-desc-part').forEach(function (el) {
      el.classList.toggle('active', hasSelection);
    });
    document.querySelectorAll('.search-box-label-part').forEach(function (el) {
      el.classList.toggle('active', hasSelection);
    });

    subDropdowns.forEach(function (el, index) {
      var dataMainId = el.getAttribute('data-id');
      var matches = dataId === dataMainId;
      var defaultActive = dataId === 'Choose One' && (index === 1 || index === 3);

      el.classList.toggle('disabled', !matches);
      el.classList.toggle('active', matches || defaultActive);

      var h5 = el.querySelector('h5');
      if (h5) h5.textContent = 'Choose one';
    });

    refreshSlick();
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target.matches || !target.matches('.our-menu-page-search-category-main select')) return;
    applyMainSelectValue(target.value);
    console.log('target.value',target.value)

    const SearchselectedValueMain = document.querySelector(
  '.our-menu-page-search-category-main select'
)?.value;

console.log('SearchselectedValue', SearchselectedValueMain);

const selectedClass = SearchselectedValueMain
  ?.trim()
  .toLowerCase()
  .replace(/\s+/g, '-');

    // A manual change means the user picked something fresh — drop any
    // stale "restore after back" value so it doesn't override this pick later.
    try {
      localStorage.removeItem('selectedMainCategoryId');
    } catch (err) {
      /* ignore */
    }
  });

  // Set initial state on load. If the user came back from a category page
  // (browser Back button), restore the main category they had selected
  // instead of resetting to "Choose One".
  var initialSelect = document.querySelector('.our-menu-page-search-category-main select');
  var restoredMainCategoryId = null;
  try {
    restoredMainCategoryId = localStorage.getItem('selectedMainCategoryId');
  } catch (err) {
    restoredMainCategoryId = null;
  }

  // One-time restore only — clear it right away so a manual page refresh
  // (not a back navigation) doesn't keep forcing the old category.
  try {
    localStorage.removeItem('selectedMainCategoryId');
  } catch (err) {
    /* ignore */
  }

  function applyInitialState() {
    if (initialSelect) {
      applyMainSelectValue(restoredMainCategoryId || initialSelect.value);
    }
    /* ---------- Sub-category dropdown open/close + selection ---------- */
    // Restore the sub-category heading text AFTER applyMainSelectValue, since
    // that call resets every h5 to "Choose one".
    restoreDropdownHeadingsFromStorage();
  }

  function runRestoreWithLayoutDelay() {
    // Toggling a hidden carousel to visible + calling slick('refresh') in
    // the same synchronous tick (before the browser has painted/laid out
    // the page) makes Slick compute 0-width slides — the list then looks
    // empty. Waiting two animation frames lets layout settle first.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(applyInitialState);
    });
  }

  if (restoredMainCategoryId) {
    runRestoreWithLayoutDelay();
  } else {
    // Nothing to restore (fresh visit, still "Choose One") — no visible
    // carousel to show yet, so no timing issue; apply immediately.
    applyInitialState();
  }

  // Some browsers restore the page from the back/forward cache (bfcache) on
  // Back — in that case DOMContentLoaded does NOT fire again, so the code
  // above never runs. pageshow with event.persisted === true tells us we're
  // in exactly that situation; re-check localStorage and re-apply so the
  // restored category still shows correctly.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var idFromStorage = null;
    try {
      idFromStorage = localStorage.getItem('selectedMainCategoryId');
    } catch (err) {
      idFromStorage = null;
    }
    if (idFromStorage) {
      restoredMainCategoryId = idFromStorage;
      try {
        localStorage.removeItem('selectedMainCategoryId');
      } catch (err) {
        /* ignore */
      }
      runRestoreWithLayoutDelay();
      refreshSlick();
    }
  });

  document.addEventListener('click', function (e) {
    var h5 = e.target.closest && e.target.closest('.our-menu-page-search-category-sub h5');
    if (h5) {
      e.preventDefault();
      var dropdown = h5
        .closest('.our-menu-page-search-category-sub')
        .querySelector('.our-menu-page-search-category-sub-dropdown');
      var wasActive = dropdown.classList.contains('active');
      document.querySelectorAll('.our-menu-page-search-category-sub-dropdown').forEach(function (d) {
        d.classList.remove('active');
      });
      if (!wasActive) dropdown.classList.add('active');
      return;
    }

    if (
      e.target.closest &&
      e.target.closest('.our-menu-page-search-category-main, .search-box-label-part, .our-menu-collections')
    ) {
      document.querySelectorAll('.our-menu-page-search-category-sub-dropdown').forEach(function (d) {
        d.classList.remove('active');
      });
    }

    var seeAll = e.target.closest && e.target.closest('.see-all-btn a');
    if (seeAll) {
      e.preventDefault();
      document.querySelectorAll('.our-menu-page-search-category-sub-dropdown').forEach(function (d) {
        d.classList.remove('active');
      });
      window.location.href = seeAll.getAttribute('href');
      return;
    }

    // Single delegated listener for all dropdown <li> items (fixes the
    // original bug where a new listener was added per item, per dropdown)
    var item = e.target.closest && e.target.closest('.our-menu-page-search-category-sub-dropdown li');
    if (item) {
      var textVal = item.textContent.trim();
      var dataLink = item.getAttribute('data-url');
      var parentDropdown = item.closest('.our-menu-page-search-category-sub-dropdown');
      var parentSub = item.closest('.our-menu-page-search-category-sub');

      if (parentSub) {
        var heading = parentSub.querySelector('h5');
        if (heading) heading.textContent = textVal;
        var storageIndex = parentSub.getAttribute('data-index') || '0';
        var parentMainCategoryId = parentSub.getAttribute('data-id') || '';
        try {
          localStorage.setItem('selectedCategoryText_' + storageIndex, textVal);
          // Remember which Meat/Dairy category this sub-category belongs to,
          // so returning via the browser Back button restores the full
          // selection (main select + active list), not just the label text.
          localStorage.setItem('selectedMainCategoryId', parentMainCategoryId);
        } catch (err) {
          /* localStorage unavailable — ignore */
        }
      }

      if (dataLink) window.location.href = dataLink;
    }
  });

  function restoreDropdownHeadingsFromStorage() {
    subDropdowns.forEach(function (el) {
      var index = el.getAttribute('data-index') || '0';
      var saved;
      try {
        saved = localStorage.getItem('selectedCategoryText_' + index);
      } catch (err) {
        saved = null;
      }
      if (saved) {
        var heading = el.querySelector('h5');
        if (heading) heading.textContent = saved;
        try {
          localStorage.setItem('selectedCategoryText_' + index, 'Choose one');
        } catch (err) {
          /* ignore */
        }
      }
    });
  }

  /* ---------- Quick view popup ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.custom-quick-popup');
    if (trigger) {
      e.preventDefault();
      document.documentElement.classList.add('popup-overflow-hidden');

      var box = trigger.closest('.our-menu-product-box');
      var sourceHtml = box ? box.querySelector('.coll-pdp-page-popup-wrap-main') : null;
      var target = document.querySelector('.coll-pdp-page-popup-section .coll-pdp-page-popup-wrap-main');
      console.log('hhhh')

      if (target) target.innerHTML = sourceHtml ? sourceHtml.innerHTML : '';

      window.requestAnimationFrame(function () {
        var popupSection = document.querySelector('.coll-pdp-page-popup-section');
        if (popupSection) popupSection.classList.add('active-popup');
      });
      return;
    }

    if (e.target.closest && e.target.closest('.coll-pdp-page-popup-close')) {
      e.preventDefault();
      var openPopup = document.querySelector('.coll-pdp-page-popup-section');
      if (openPopup) openPopup.classList.remove('active-popup');
      document.documentElement.classList.remove('popup-overflow-hidden');
    }
  });

  /* ---------- Popup price / qty / variant handling ---------- */
  function formatPrice(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function updatePopupPrice() {
    var popup = document.querySelector('.coll-pdp-page-popup-section.active-popup');
    if (!popup) return;

    var qtyInput = popup.querySelector('.quantity__input');
    var priceSpan = popup.querySelector('.coll-pdp-page-popup-price span');
    var priceStrike = popup.querySelector('.coll-pdp-page-popup-price s');
    if (!qtyInput || !priceSpan) return;

    var qty = parseInt(qtyInput.value, 10) || 1;
    var mainPrice = parseFloat(priceSpan.getAttribute('main-price')) || 0;
    priceSpan.textContent = formatPrice(qty * mainPrice);

    if (priceStrike) {
      var mainComPrice = priceStrike.getAttribute('main-price');
      if (mainComPrice) {
        priceStrike.style.display = '';
        priceStrike.textContent = formatPrice(qty * parseFloat(mainComPrice));
      } else {
        priceStrike.style.display = 'none';
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.quantity__button')) {
      window.requestAnimationFrame(updatePopupPrice);
    }
  });

  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('.coll-pdp-page-popup-var-price li');
    if (!li) return;

    var list = li.closest('.coll-pdp-page-popup-var-price');
    list.querySelectorAll('li').forEach(function (el) {
      el.classList.remove('active');
    });
    li.classList.add('active');

    var popup = document.querySelector('.coll-pdp-page-popup-section.active-popup');
    if (!popup) return;

    var priceSpan = popup.querySelector('.coll-pdp-page-popup-price span');
    var priceStrike = popup.querySelector('.coll-pdp-page-popup-price s');
    var qtyInput = popup.querySelector('.quantity__input');
    var cartBtn = popup.querySelector('.coll-pdp-popup-cart-btn');
    var smallDesc = popup.querySelector('.pdp-package-small-desc');
    var smallDescMain = popup.querySelector('.product-serves-small');

    console.log('smallDescMain',smallDescMain)

    if (priceSpan) priceSpan.setAttribute('main-price', li.getAttribute('main-price'));
    if (priceStrike) priceStrike.setAttribute('main-price', li.getAttribute('main-com-price') || '');
    if (smallDesc) smallDesc.textContent = li.getAttribute('data-variant-serves-small') || '';
    if (smallDescMain) smallDescMain.textContent = li.getAttribute('data-variant-serves-small') || '';
    if (cartBtn) cartBtn.setAttribute('data-id', li.getAttribute('data-id'));

    if (qtyInput) {
      var qty = li.getAttribute('data-qty') || '1';
      qtyInput.value = qty;
      qtyInput.setAttribute('data-min', qty);
      qtyInput.setAttribute('min', qty);
    }

    window.requestAnimationFrame(updatePopupPrice);
  });

  /* ---------- Live search ---------- */
  // Scoped to the ORIGINAL search bar specifically — the sticky top bar is
  // a clone with its own .js-search-box__input, and an unscoped query could
  // grab that hidden clone instead of the visible input depending on DOM
  // order, which silently breaks typing-to-filter.
//   var searchInput = document.querySelector('.our-menu-page-search-bar-part-wc .js-search-box__input');
//   var productBoxes = document.querySelectorAll('.our-menu-product-box');
//   var listBoxes = document.querySelectorAll('.our-menu-collections');
//   var searchListParts = document.querySelectorAll('.our-menu-product-search-list-part');
//   const SearchselectedValueMain = document.querySelector(
//   '.our-menu-page-search-category-main select'
// )?.value;

// console.log('SearchselectedValue', SearchselectedValueMain);

// const selectedClass = SearchselectedValueMain
//   ?.trim()
//   .toLowerCase()
//   .replace(/\s+/g, '-');


//   if (searchInput) {
//     var debounceTimer;
//     searchInput.addEventListener('input', function () {
//       clearTimeout(debounceTimer);
//       debounceTimer = setTimeout(function () {
//         var value = searchInput.value.toLowerCase().trim();
//         var isSearching = value.length > 0;

//         listBoxes.forEach(function (list) {
//           list.style.display = isSearching ? 'block' : 'none';
//         });
//         searchListParts.forEach(function (part) {
//           part.style.display = isSearching ? 'flex' : 'none';
//           if (selectedClass && selectedClass !== 'choose-one') {
//    // part.classList.add(`main-search-hide-show-base-${selectedClass}`);
//   }
//         });

//         productBoxes.forEach(function (box) {
//           var titleEl = box.querySelector('.suggest-product-title');
//           var titleText = titleEl ? titleEl.textContent.toLowerCase() : '';
//           box.style.display = titleText.indexOf(value) !== -1 ? '' : 'none';
//         });

//         document.querySelectorAll('.no-result').forEach(function (el) {
//           el.style.display = 'none';
//         });

//         refreshSlick();
//       }, 120); // debounce so filtering doesn't run on every single keystroke
//     });

//     // Keep the sticky top bar's cloned input showing the same text (cosmetic
//     // sync only — the clone doesn't run its own filter logic).
//     searchInput.addEventListener('input', function () {
//       var stickyInput = document.querySelector('.coll-filter-bar-top .js-search-box__input');
//       if (stickyInput && stickyInput !== searchInput) {
//         stickyInput.value = searchInput.value;
//       }
//     });
//   }


const searchInputs = document.querySelectorAll(".js-search-box__input");
    const productBoxes = document.querySelectorAll(".our-menu-product-box");
    const listBoxes = document.querySelectorAll(".our-menu-collections");
    const searchClass = document.querySelectorAll(
        ".our-menu-product-search-list-part"
    );

    const SearchselectedValueMain = document.querySelector(
        ".our-menu-page-search-category-main select"
    )?.value;

    console.log("SearchselectedValue", SearchselectedValueMain);

    if (searchInputs.length > 0) {
        searchInputs.forEach(function (searchInput) {
            searchInput.addEventListener("input", function () {
                const currentValue = this.value;
                const searchValue = currentValue.toLowerCase().trim();

                // Sync all search inputs
                searchInputs.forEach(function (input) {
                    if (input !== searchInput) {
                        input.value = currentValue;
                    }
                });

                // Show/hide collection list boxes
                listBoxes.forEach(function (list) {
                    list.style.display =
                        searchValue.length === 0 ? "block" : "none";
                });

                // Show/hide search result containers
                searchClass.forEach(function (search) {
                    search.style.display =
                        searchValue.length === 0 ? "none" : "flex";
                });

                // Filter product boxes
                productBoxes.forEach(function (box) {
                    const titleElement = box.querySelector(
                        ".suggest-product-title"
                    );

                    const titleText = titleElement
                        ? titleElement.textContent.toLowerCase()
                        : "";

                    box.style.display = titleText.includes(searchValue)
                        ? ""
                        : "none";
                });

                // Hide no-result messages
                document.querySelectorAll(".no-result").forEach(function (el) {
                    el.style.display = "none";
                });

                // Refresh initialized Slick sliders
                $(".our-menu-collection-products-1").each(function () {
                    if ($(this).hasClass("slick-initialized")) {
                        $(this).slick("refresh");
                    }
                });
            });
        });
    }

  /* ---------- Keep the two select copies (main + sticky) in sync on the fly ---------- */
  // Already handled above by applyMainSelectValue(), which writes to
  // every '.our-menu-page-search-category-main select' on change.
});


// document.addEventListener("DOMContentLoaded", function () {
//     const searchInput = document.querySelector(".js-search-box__input");
//     const productBoxes = document.querySelectorAll(".our-menu-product-box");
//     const listBoxes = document.querySelectorAll(".our-menu-collections"); // Assuming you have these elements
//     const searchClass = document.querySelectorAll(".our-menu-product-search-list-part");
    

//     if (searchInput) {
//         searchInput.addEventListener("input", function () {
//             const searchValue = this.value.toLowerCase().trim();

//             // Show/hide collection list boxes based on search value
//             listBoxes.forEach(function (list) {
//                 list.style.display = searchValue.length === 0 ? "block" : "none";
//             });
//             searchClass.forEach(function (search) {
//                 search.style.display = searchValue.length === 0 ? "none" : "flex";
//             });

//             // Filter product boxes
//             productBoxes.forEach(function (box) {
//                 const titleElement = box.querySelector(".suggest-product-title");
//                 const titleText = titleElement ? titleElement.textContent.toLowerCase() : "";

//                 if (titleText.includes(searchValue)) {
//                     box.style.display = "";
//                 } else {
//                     box.style.display = "none";
//                 }
//             });

//             const noResults = document.querySelectorAll(".no-result");

// noResults.forEach(el => {
//   el.style.display = "none";
// });

//   $('.our-menu-collection-products-1').slick('refresh');
// setTimeout(function(){
//   $('.our-menu-collection-products-1').slick('refresh');
// }, 100)

// // const items = document.querySelectorAll(".our-menu-product-search-list-part .our-menu-product-box");
// // const visibleCount = Array.from(items).filter(el => getComputedStyle(el).display !== 'none').length;
// // console.log('visibleCount',visibleCount)
// // noResults.forEach(el => {
// //   el.style.display = visibleCount === 0 ? "block" : "none";
// // });


// // setTimeout(function(){
// // var this_val = $('.our-menu-page-search-category select option:selected').val();
// //     const searchInput = document.querySelector(".js-search-box__input");
// //     const productBoxes = document.querySelectorAll(".our-menu-product-search-list-part .our-menu-product-box");
// //     const listBoxes = document.querySelectorAll(".our-menu-collections"); // Assuming you have these elements
// //     const searchClass = document.querySelectorAll(".our-menu-product-search-list-part");
// //     const noResults = document.querySelectorAll(".no-result"); // NodeList

// // setTimeout(function(){
// //             const items = document.querySelectorAll(".our-menu-product-search-list-part .our-menu-product-box");
// // const visibleCount = Array.from(items).filter(el => getComputedStyle(el).display !== 'none').length;

// // noResults.forEach(el => {
// //   el.style.display = visibleCount === 0 ? "block" : "none";
// // });
// // }, 50)

// // }, 300)

//         });
//     }
// });


document.addEventListener("DOMContentLoaded", function () {
    const searchInputs = document.querySelectorAll(".js-search-box__input");
    const productBoxes = document.querySelectorAll(".our-menu-product-box");
    const listBoxes = document.querySelectorAll(".our-menu-collections");
    const searchClass = document.querySelectorAll(
        ".our-menu-product-search-list-part"
    );

    const SearchselectedValueMain = document.querySelector(
        ".our-menu-page-search-category-main select"
    )?.value;

    console.log("SearchselectedValue", SearchselectedValueMain);

    if (searchInputs.length > 0) {
        searchInputs.forEach(function (searchInput) {
            searchInput.addEventListener("input", function () {
                const currentValue = this.value;
                const searchValue = currentValue.toLowerCase().trim();

                // Sync all search inputs
                searchInputs.forEach(function (input) {
                    if (input !== searchInput) {
                        input.value = currentValue;
                    }
                });

                // Show/hide collection list boxes
                listBoxes.forEach(function (list) {
                    list.style.display =
                        searchValue.length === 0 ? "block" : "none";
                });

                // Show/hide search result containers
                searchClass.forEach(function (search) {
                    search.style.display =
                        searchValue.length === 0 ? "none" : "flex";
                });

                // Filter product boxes
                productBoxes.forEach(function (box) {
                    const titleElement = box.querySelector(
                        ".suggest-product-title"
                    );

                    const titleText = titleElement
                        ? titleElement.textContent.toLowerCase()
                        : "";

                    box.style.display = titleText.includes(searchValue)
                        ? ""
                        : "none";
                });

                // Hide no-result messages
                document.querySelectorAll(".no-result").forEach(function (el) {
                    el.style.display = "none";
                });

                // Refresh initialized Slick sliders
                $(".our-menu-collection-products-1").each(function () {
                    if ($(this).hasClass("slick-initialized")) {
                        $(this).slick("refresh");
                    }
                });
            });
        });
    }
});

 


